import p from "./highrise987.mjs";
import { composite as r } from "./highrise993.mjs";
function s(t) {
  const {
    borderRadius: i,
    avatarColor: o,
    cardColor: e,
    fontSize: a,
    heightTiny: l,
    heightSmall: d,
    heightMedium: h,
    heightLarge: m,
    heightHuge: c,
    modalColor: g,
    popoverColor: n
  } = t;
  return {
    borderRadius: i,
    fontSize: a,
    border: `2px solid ${e}`,
    heightTiny: l,
    heightSmall: d,
    heightMedium: h,
    heightLarge: m,
    heightHuge: c,
    color: r(e, o),
    colorModal: r(g, o),
    colorPopover: r(n, o)
  };
}
const v = {
  common: p,
  self: s
};
export {
  v as default,
  s as self
};
